import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "page-header" }
const _hoisted_4 = { class: "page-body" }
const _hoisted_5 = {
  key: 0,
  class: "card"
}
const _hoisted_6 = { class: "meta-grid" }
const _hoisted_7 = { class: "meta-item" }
const _hoisted_8 = { class: "meta-val" }
const _hoisted_9 = { class: "meta-item" }
const _hoisted_10 = { class: "meta-val" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "table-wrap" }
const _hoisted_13 = { class: "participantes-table" }
const _hoisted_14 = { class: "td-rol" }
const _hoisted_15 = {
  key: 1,
  class: "card"
}
const _hoisted_16 = {
  key: 0,
  class: "objetivo-block"
}
const _hoisted_17 = { class: "objetivo-text" }
const _hoisted_18 = {
  key: 1,
  class: "indicador-chip"
}
const _hoisted_19 = { class: "ind-nombre" }
const _hoisted_20 = {
  key: 2,
  class: "card grupos-card"
}
const _hoisted_21 = { class: "grupos-toolbar" }
const _hoisted_22 = {
  key: 0,
  class: "ind-formulario-ref"
}
const _hoisted_23 = { class: "ind-nombre" }
const _hoisted_24 = { class: "vista-toggle" }
const _hoisted_25 = { class: "grupo-header" }
const _hoisted_26 = {
  key: 0,
  class: "meta-chip"
}
const _hoisted_27 = {
  key: 0,
  class: "grupo-criterios"
}
const _hoisted_28 = {
  key: 1,
  class: "preguntas-panel"
}
const _hoisted_29 = { class: "preguntas-head" }
const _hoisted_30 = { class: "pill" }
const _hoisted_31 = { class: "qh" }
const _hoisted_32 = { class: "qn" }
const _hoisted_33 = { class: "qt" }
const _hoisted_34 = {
  key: 0,
  class: "tag"
}
const _hoisted_35 = ["title"]
const _hoisted_36 = ["title"]
const _hoisted_37 = {
  key: 0,
  class: "opciones"
}
const _hoisted_38 = {
  key: 1,
  class: "distribucion"
}
const _hoisted_39 = { class: "dist-opcion" }
const _hoisted_40 = { class: "dist-bar-wrap" }
const _hoisted_41 = { class: "dist-pct" }
const _hoisted_42 = {
  key: 2,
  class: "resp-show"
}
const _hoisted_43 = {
  key: 3,
  class: "tabla-opinion"
}
const _hoisted_44 = { class: "tabla-evaluacion" }
const _hoisted_45 = {
  key: 1,
  class: "q-control"
}
const _hoisted_46 = {
  key: 0,
  class: "fp-opts"
}
const _hoisted_47 = {
  key: 0,
  class: "fp-hint"
}
const _hoisted_48 = {
  key: 1,
  class: "fp-opts"
}
const _hoisted_49 = {
  key: 0,
  class: "fp-hint"
}
const _hoisted_50 = {
  key: 2,
  class: "fp-select",
  disabled: ""
}
const _hoisted_51 = {
  key: 3,
  class: "fp-escala"
}
const _hoisted_52 = {
  key: 0,
  class: "fp-escala-lbl"
}
const _hoisted_53 = {
  key: 1,
  class: "fp-escala-lbl"
}
const _hoisted_54 = {
  key: 4,
  type: "text",
  class: "fp-input",
  disabled: "",
  placeholder: "Texto de respuesta corta"
}
const _hoisted_55 = {
  key: 5,
  type: "date",
  class: "fp-input fp-input-sm",
  disabled: ""
}
const _hoisted_56 = {
  key: 6,
  type: "time",
  class: "fp-input fp-input-sm",
  disabled: ""
}
const _hoisted_57 = {
  key: 7,
  class: "tabla-opinion"
}
const _hoisted_58 = { class: "tabla-evaluacion" }
const _hoisted_59 = {
  key: 8,
  class: "fp-textarea",
  disabled: "",
  placeholder: "Texto de respuesta larga"
}
const _hoisted_60 = {
  key: 2,
  class: "sin-preguntas"
}
const _hoisted_61 = {
  key: 3,
  class: "card sin-grupos"
}
const _hoisted_62 = {
  key: 4,
  class: "empty-state"
}
const _hoisted_63 = { class: "botones" }

import { useRoute, useRouter } from 'vue-router'
import { ref, computed, onMounted } from 'vue'
import LoadingOverlay from './LoadingOverlay.vue'
import MensajeFlotante from './MensajeFlotante.vue'
import InstrumentosView from '@/views/InstrumentosView.vue'
import ModificarFormularioModal from './ModificarFormularioModal.vue'
import useAutenticar from '@/store/IngresoAutenticar'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'


import { useGestionGrupoInteres } from '@/store/GestionGrupoInteres'
import { useGestionPreguntas } from '@/store/GestionPreguntas'
import { useGestionConfiguracionInstrumento } from '@/store/GestionConfiguracionInstrumento'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import { http } from '@/services/http'


export default /*@__PURE__*/_defineComponent({
  __name: 'InstrumentoDetalle',
  setup(__props) {

/**
 * Detalle de un instrumento y sus preguntas.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const route = useRoute()
const router = useRouter()
const authStore = useAutenticar()

const instrumentoStore = useGestionInstrumento()
const relacionStore = useGestionIndicadorInstrumentos()


const grupoStore = useGestionGrupoInteres()
const preguntaStore = useGestionPreguntas()
const configStore = useGestionConfiguracionInstrumento()
const tipoComponenteStore = useGestionTipoComponente()

const instrumento = ref<any>(null)
const indicador = ref<any>(null)
const componente = ref<any>(null)
const relacion = ref<any>(null)
const gruposConPreguntas = ref<any[]>([])
const loading = ref(true)
const loadingModificar = ref(false)
const mostrarModalInstrumento = ref(false)
const mostrarModificarFormulario = ref(false)

// Usa el tipo del indicador (mismo criterio que FilaComponente.esIndicadorDeOpinion)
// para que la validación sea consistente en toda la app.
const esOpinion = computed(() => {
  if (!indicador.value?.id_tipo_componente) return false
  const tipo = (tipoComponenteStore.tipos ?? []).find(
    (t: any) => t.id_tipo_componente === indicador.value.id_tipo_componente
  )
  return /opini/i.test(String(tipo?.nombre ?? ''))
})
const vistaPreguntas = ref<'lista' | 'formulario'>('lista')

const tipo = computed(() => {
  const h = (instrumento.value?.herramienta || '').toLowerCase()
  if (h.includes('encuesta')) return 'encuesta'
  if (h.includes('entrevista')) return 'entrevista'
  if (h.includes('focal') || h.includes('focale')) return 'grupofocal'
  if (h.includes('taller') || h.includes('mesa')) return 'taller'
  return 'otro'
})

const esEncuesta     = computed(() => tipo.value === 'encuesta')
const tipoReconocido = computed(() => ['encuesta','entrevista','grupofocal','taller'].includes(tipo.value))

const tituloTipo = computed(() => {
  const map: Record<string, string> = {
    encuesta:   'Encuesta',
    entrevista: 'Entrevista',
    grupofocal: 'Grupo Focal',
    taller:     'Mesa-Taller',
    otro:       instrumento.value?.herramienta || 'Instrumento'
  }
  return map[tipo.value]
})

const rolesParticipantes = computed((): string[] => {
  if (tipo.value === 'entrevista') return ['Entrevistado', 'Entrevistador', 'Relator / Observador']
  if (tipo.value === 'grupofocal') return ['Moderador', 'Relator', 'Observador', 'Participante', 'Participante']
  if (tipo.value === 'taller')     return ['Facilitador', 'Relator', 'Participante', 'Observador']
  return ['Participante', 'Participante', 'Participante']
})

const metaEstamento = computed(() =>
  gruposConPreguntas.value.map(g => g.nombre).filter(Boolean).join(', ') || null
)

const actividad      = ref<any>(null)
const objetivo       = ref<string | null>(null)
const observaciones  = ref<string | null>(null)
const roles          = ref<any[]>([])
const participantes  = ref<any[]>([])
const vigenciaDesde  = ref<string | null>(null)

const mensajeVisible = ref(false)
const mensajeTexto   = ref('')
const mensajeTipo    = ref<'positivo' | 'error'>('positivo')

function formatearFecha(fecha: string | null): string {
  if (!fecha) return '—'
  const d = new Date(fecha)
  if (isNaN(d.getTime())) return fecha
  return d.toLocaleDateString('es-CO', { day: '2-digit', month: 'long', year: 'numeric' })
}

function etiquetaTipo(t: string): string {
  const map: Record<string, string> = {
    single_choice:   'Opción única',
    opcion_unica:    'Opción única',
    opcion_multiple: 'Opción única',
    multiple_choice: 'Casillas',
    casillas:        'Casillas',
    checkbox:        'Casillas',
    desplegable:     'Lista desplegable',
    dropdown:        'Lista desplegable',
    opinion:         'Opinión',
    long_text:       'Párrafo',
    parrafo:         'Párrafo',
    texto:           'Párrafo',
    abierta:         'Abierta',
    respuesta_corta: 'Respuesta corta',
    numerica:        'Respuesta corta',
    escala_likert:   'Escala Likert',
    escala_lineal:   'Escala lineal',
    linear_scale:    'Escala lineal',
    rating:          'Escala lineal',
    fecha:           'Fecha',
    hora:            'Hora'
  }
  return map[t] || t
}

function opcionesLista(p: any): string[] {
  return Array.isArray(p?.opciones) ? p.opciones : []
}

/** Categoría de control para la previsualización estilo Google Forms. */
function categoriaControl(p: any): string {
  const t = p?.tipo_respuesta || p?.tipo || ''
  if (['single_choice', 'opcion_unica', 'opcion_multiple'].includes(t)) return 'radio'
  if (['multiple_choice', 'casillas', 'checkbox'].includes(t)) return 'checkbox'
  if (['desplegable', 'dropdown'].includes(t)) return 'select'
  if (['escala_likert', 'escala_lineal', 'linear_scale', 'rating'].includes(t)) return 'escala'
  if (['respuesta_corta', 'numerica'].includes(t)) return 'corta'
  if (['fecha', 'date'].includes(t)) return 'fecha'
  if (['hora', 'time'].includes(t)) return 'hora'
  if (t === 'opinion') return 'opinion'
  return 'parrafo'
}

/** Rango y etiquetas de una escala (likert fija 1-5 o lineal configurable). */
function escalaInfo(p: any): { rango: number[]; min: string; max: string } {
  const t = p?.tipo_respuesta || p?.tipo
  if (t === 'escala_likert') return { rango: [1, 2, 3, 4, 5], min: '', max: '' }
  const o = p?.opciones && !Array.isArray(p.opciones) ? p.opciones : {}
  const min = Number(o.min ?? 1)
  const max = Number(o.max ?? 5)
  const rango: number[] = []
  for (let n = min; n <= max && rango.length < 20; n++) rango.push(n)
  return {
    rango: rango.length ? rango : [1, 2, 3, 4, 5],
    min: o.etiqueta_min ?? '',
    max: o.etiqueta_max ?? '',
  }
}


function colorOpcion(idx: number, total: number): string {
  const pct = total > 1 ? Math.round((idx / (total - 1)) * 100) : 100
  if (pct >= 80) return '#2e7d32'
  if (pct >= 60) return '#558b2f'
  if (pct >= 40) return '#f9a825'
  if (pct >= 20) return '#e65100'
  return '#c62828'
}

function normalizarDistribucion(distribucion: any): Array<{ opcion: string; pct: number }> {
  if (!distribucion || typeof distribucion !== 'object') return []
  const entries = Object.entries(distribucion)
  const total = entries.reduce((s, [, v]) => s + Number(v), 0)
  if (!total) return []
  return entries.map(([k, v]) => ({ opcion: k, pct: Math.round((Number(v) / total) * 100) }))
}

function mapearPorTipo(inst: any) {
  if (!inst) return
  actividad.value     = inst.actividad ?? null
  objetivo.value      = inst.objetivo ?? null
  observaciones.value = inst.observaciones ?? null
  roles.value         = inst.roles ?? []
  participantes.value = inst.participantes ?? []
}

async function cargarDetalle() {
  loading.value = true
  const idInstrumento = Number(route.params.id)
  if (!idInstrumento) { loading.value = false; return }

  try {
    const inst = await instrumentoStore.getInstrumentoById(idInstrumento)
    if (!tipoComponenteStore.tipos.length) await tipoComponenteStore.getTipos()

    let gruposResult: any[] = []
    if (inst?.grupos_interes?.length) {
      await grupoStore.getGrupos()
      const todasPreguntas = await preguntaStore.getPreguntas({ id_instrumento: idInstrumento })

      // Si el backend no devuelve indicadores[] con enunciado, los cargamos
      // usando id_indicador. Se hace en paralelo para no serializar las llamadas.
      const idsIndicador = [...new Set(
        (todasPreguntas ?? [])
          .filter((p: any) => p.id_indicador && !(Array.isArray(p.indicadores) && p.indicadores.length))
          .map((p: any) => Number(p.id_indicador))
      )]
      const nombreIndicador: Record<number, string> = {}
      await Promise.all(idsIndicador.map(async (idInd) => {
        const r = await http.get<any>(`/api/indicadores/${idInd}`)
        if (r.ok) {
          const ind = r.data?.data ?? r.data
          if (ind?.enunciado) nombreIndicador[idInd] = ind.enunciado
        }
      }))

      let preguntasPorGrupoApi: any = null
      try { preguntasPorGrupoApi = await instrumentoStore.getPreguntasPorGrupo(idInstrumento) } catch { /* ignorar */ }

      gruposResult = inst.grupos_interes.map((g: any) => {
        const grupoInfo = grupoStore.grupos.find(
          (gr: any) => gr.id_grupo_interes === (g.id_grupo_interes ?? g.id)
        )
        const idGrupo = g.id_grupo_interes ?? g.id ?? grupoInfo?.id_grupo_interes
        let preguntasDelGrupo: any[] = []

        if (preguntasPorGrupoApi) {
          const apiGrupos = Array.isArray(preguntasPorGrupoApi)
            ? preguntasPorGrupoApi
            : (preguntasPorGrupoApi?.grupos ?? [])
          const found = apiGrupos.find(
            (gc: any) => (gc.id_grupo_interes ?? gc.grupo?.id_grupo_interes) === idGrupo
          )
          preguntasDelGrupo = found?.preguntas ?? []
        }

        if (!preguntasDelGrupo.length && todasPreguntas?.length) {
          // Las preguntas generales (id_grupo_interes null) aplican a todos los grupos.
          preguntasDelGrupo = todasPreguntas.filter(
            (p: any) => p.id_grupo_interes === idGrupo || p.id_grupo_interes == null
          )
        }

        if (!preguntasDelGrupo.length && (g.preguntas?.length || grupoInfo?.preguntas?.length)) {
          const embebidas = g.preguntas || grupoInfo?.preguntas || []
          preguntasDelGrupo = embebidas.filter(
            (p: any) => !p.instrumento || p.instrumento?.id_instrumento === idInstrumento
          )
        }

        return {
          id_grupo_interes: idGrupo,
          nombre:        grupoInfo?.nombre       ?? g.nombre       ?? `Grupo ${idGrupo}`,
          tipo_muestreo: grupoInfo?.tipo_muestreo ?? g.tipo_muestreo,
          criterios:     grupoInfo?.criterios     ?? g.criterios,
          preguntas: preguntasDelGrupo.map((p: any) => ({
            id_pregunta:   p.id_pregunta,
            enunciado:     p.enunciado    ?? p.pregunta,
            pregunta:      p.pregunta     ?? p.enunciado,
            tipo_respuesta: p.tipo_respuesta ?? p.tipo,
            tipo:          p.tipo          ?? p.tipo_respuesta,
            opciones:      p.opciones      ?? [],
            variantes:     p.variantes     ?? [],
            criterios:     p.criterios     ?? [],
            distribucion:  p.distribucion  ?? null,
            id_indicador:  p.id_indicador  ?? null,
            indicadores:   (() => {
              const existing = Array.isArray(p.indicadores) ? p.indicadores : []
              if (existing.length) return existing
              const idInd = p.id_indicador ?? null
              return idInd && nombreIndicador[idInd]
                ? [{ id_indicador: idInd, enunciado: nombreIndicador[idInd], id_version: 0 }]
                : []
            })()
          }))
        }
      })
    }

    gruposConPreguntas.value = gruposResult
    instrumento.value = inst

    await configStore.listar({ id_instrumento: idInstrumento })
    vigenciaDesde.value = configStore.configuraciones[0]?.vigencia_desde ?? null

    // Cargar componente: desde el query (navegación desde FilaComponente) o vía relación-indicador
    const idCompQuery = Number(route.query.id_componente)
    if (idCompQuery) {
      const rComp = await http.get<any>(`/api/componentes/${idCompQuery}`)
      componente.value = rComp.ok ? (rComp.data?.data ?? rComp.data ?? null) : null
    }

    if (!relacionStore.relaciones.length) await relacionStore.getRelaciones()
    const rel = relacionStore.relaciones.find(r => r.id_instrumento === idInstrumento)
    relacion.value = rel

    if (rel?.id_indicador) {
      const rInd = await http.get<any>(`/api/indicadores/${rel.id_indicador}`)
      const rawInd = rInd.ok ? (rInd.data?.data ?? rInd.data ?? null) : null
      indicador.value = rawInd

      if (!componente.value) {
        const idComp = rawInd?.id_componente ?? rawInd?.componente?.id_componente
        if (idComp) {
          const rComp = await http.get<any>(`/api/componentes/${idComp}`)
          componente.value = rComp.ok ? (rComp.data?.data ?? rComp.data ?? null) : null
        }
      }
    }

    mapearPorTipo(inst)
  } catch (e: any) {
    console.error('Error al cargar detalle del instrumento:', e)
    mensajeTexto.value  = 'Error al cargar el instrumento.'
    mensajeTipo.value   = 'error'
    mensajeVisible.value = true
  } finally {
    loading.value = false
  }
}

onMounted(cargarDetalle)

function modificarInstrumento() {
  if (!instrumento.value) return
  if (esOpinion.value) {
    mostrarModificarFormulario.value = true
  } else {
    mostrarModalInstrumento.value = true
  }
}

function onFormularioGuardado(mensaje: string) {
  mensajeTexto.value  = mensaje
  mensajeTipo.value   = 'positivo'
  mensajeVisible.value = true
}

async function cerrarModalInstrumento() {
  mostrarModalInstrumento.value = false
  await cargarDetalle()
}

async function cerrarModalFormulario() {
  mostrarModificarFormulario.value = false
  await cargarDetalle()
}

function volver() { router.back() }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      visible: loading.value,
      message: "Cargando instrumento..."
    }, null, 8, ["visible"]),
    _createVNode(LoadingOverlay, {
      visible: loadingModificar.value,
      message: "Cargando datos para modificar..."
    }, null, 8, ["visible"]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _createElementVNode("h1", null, _toDisplayString(tituloTipo.value) + " — Datos de la actividad", 1)
          ]),
          _createElementVNode("main", _hoisted_4, [
            (instrumento.value)
              ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "meta-label" }, "Fecha", -1)),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(formatearFecha(vigenciaDesde.value)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "meta-label" }, "Grupos de Interés", -1)),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(metaEstamento.value || '—'), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_11, [
              _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Participantes y roles", -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Rol"),
                      _createElementVNode("th", null, "Nombre"),
                      _createElementVNode("th", null, "Cargo")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rolesParticipantes.value, (rol) => {
                      return (_openBlock(), _createElementBlock("tr", { key: rol }, [
                        _createElementVNode("td", _hoisted_14, _toDisplayString(rol), 1),
                        _cache[5] || (_cache[5] = _createElementVNode("td", null, null, -1)),
                        _cache[6] || (_cache[6] = _createElementVNode("td", null, null, -1))
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            (instrumento.value || indicador.value)
              ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
                  _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Objetivo y tema", -1)),
                  (instrumento.value?.descripcion || objetivo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "meta-label" }, "Objetivo", -1)),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(instrumento.value?.descripcion || objetivo.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (indicador.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ind-badge" }, "Indicador", -1)),
                        _createElementVNode("span", _hoisted_19, "— " + _toDisplayString(componente.value?.nombre ?? '—'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (gruposConPreguntas.value.length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "grupos-title" }, "Formulario", -1)),
                    (instrumento.value?.modalidad === 'formulario_completo' && indicador.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "ind-badge" }, "Califica:", -1)),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(indicador.value.enunciado), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", {
                        class: _normalizeClass(['vista-btn', { 'vista-btn--activo': vistaPreguntas.value === 'lista' }]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (vistaPreguntas.value = 'lista'))
                      }, "Lista", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(['vista-btn', { 'vista-btn--activo': vistaPreguntas.value === 'formulario' }]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (vistaPreguntas.value = 'formulario'))
                      }, "Formulario", 2)
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gruposConPreguntas.value, (g) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: g.id_grupo_interes,
                      class: "grupo-block"
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("h3", null, _toDisplayString(g.nombre || 'Grupo sin nombre'), 1),
                        (g.tipo_muestreo)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(g.tipo_muestreo), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (g.criterios)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                            _cache[14] || (_cache[14] = _createElementVNode("strong", null, "Criterios:", -1)),
                            _createTextVNode(" " + _toDisplayString(g.criterios), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (g.preguntas?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "preguntas-label" }, "Preguntas", -1)),
                              _createElementVNode("span", _hoisted_30, _toDisplayString(g.preguntas.length), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.preguntas, (p, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: p.id_pregunta || idx,
                                class: "q"
                              }, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("span", _hoisted_32, _toDisplayString(Number(idx) + 1), 1),
                                  _createElementVNode("span", _hoisted_33, _toDisplayString(p.enunciado || p.pregunta), 1),
                                  (p.tipo_respuesta || p.tipo)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(etiquetaTipo(p.tipo_respuesta || p.tipo)), 1))
                                    : _createCommentVNode("", true),
                                  (p.indicadores?.length)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(p.indicadores, (ind) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: ind.id_indicador,
                                          class: "tag tag--ind",
                                          title: ind.enunciado
                                        }, _toDisplayString(ind.enunciado), 9, _hoisted_35))
                                      }), 128))
                                    : (p.id_indicador)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 2,
                                          class: "tag tag--ind",
                                          title: componente.value?.nombre ?? `Indicador #${p.id_indicador}`
                                        }, _toDisplayString(componente.value?.nombre ?? `Indicador #${p.id_indicador}`), 9, _hoisted_36))
                                      : _createCommentVNode("", true)
                                ]),
                                (vistaPreguntas.value === 'lista')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (Array.isArray(p.opciones) && p.opciones.length)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_37, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.opciones, (o, i) => {
                                              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(o), 1))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (p.distribucion && esEncuesta.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(normalizarDistribucion(p.distribucion), (item, i) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: i,
                                                class: "dist-row"
                                              }, [
                                                _createElementVNode("span", _hoisted_39, _toDisplayString(item.opcion), 1),
                                                _createElementVNode("div", _hoisted_40, [
                                                  _createElementVNode("div", {
                                                    class: "dist-bar",
                                                    style: _normalizeStyle({ width: item.pct + '%', background: colorOpcion(i, normalizarDistribucion(p.distribucion).length) })
                                                  }, null, 4)
                                                ]),
                                                _createElementVNode("span", _hoisted_41, _toDisplayString(item.pct) + "%", 1)
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (['abierta','long_text'].includes(p.tipo_respuesta || p.tipo))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[16] || (_cache[16] = [
                                            _createElementVNode("span", { class: "muted" }, "Respuesta abierta…", -1)
                                          ])))
                                        : _createCommentVNode("", true),
                                      ((p.tipo_respuesta || p.tipo) === 'opinion')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                            _createElementVNode("table", _hoisted_44, [
                                              _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                  _cache[17] || (_cache[17] = _createElementVNode("th", null, "Variante", -1)),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.criterios, (c, i) => {
                                                    return (_openBlock(), _createElementBlock("th", { key: i }, _toDisplayString(c), 1))
                                                  }), 128))
                                                ])
                                              ]),
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.variantes, (v, i) => {
                                                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                                    _createElementVNode("td", null, _toDisplayString(v), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.criterios, (_, j) => {
                                                      return (_openBlock(), _createElementBlock("td", { key: j }, _cache[18] || (_cache[18] = [
                                                        _createElementVNode("input", {
                                                          type: "checkbox",
                                                          disabled: ""
                                                        }, null, -1)
                                                      ])))
                                                    }), 128))
                                                  ]))
                                                }), 128))
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                      (categoriaControl(p) === 'radio')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesLista(p), (o, i) => {
                                              return (_openBlock(), _createElementBlock("label", {
                                                key: i,
                                                class: "fp-opt"
                                              }, [
                                                _cache[19] || (_cache[19] = _createElementVNode("input", {
                                                  type: "radio",
                                                  disabled: ""
                                                }, null, -1)),
                                                _createElementVNode("span", null, _toDisplayString(o), 1)
                                              ]))
                                            }), 128)),
                                            (!opcionesLista(p).length)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_47, "Sin opciones definidas"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : (categoriaControl(p) === 'checkbox')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesLista(p), (o, i) => {
                                                return (_openBlock(), _createElementBlock("label", {
                                                  key: i,
                                                  class: "fp-opt"
                                                }, [
                                                  _cache[20] || (_cache[20] = _createElementVNode("input", {
                                                    type: "checkbox",
                                                    disabled: ""
                                                  }, null, -1)),
                                                  _createElementVNode("span", null, _toDisplayString(o), 1)
                                                ]))
                                              }), 128)),
                                              (!opcionesLista(p).length)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_49, "Sin opciones definidas"))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (categoriaControl(p) === 'select')
                                            ? (_openBlock(), _createElementBlock("select", _hoisted_50, [
                                                _cache[21] || (_cache[21] = _createElementVNode("option", null, "Elegir…", -1)),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesLista(p), (o, i) => {
                                                  return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(o), 1))
                                                }), 128))
                                              ]))
                                            : (categoriaControl(p) === 'escala')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                  (escalaInfo(p).min)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(escalaInfo(p).min), 1))
                                                    : _createCommentVNode("", true),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(escalaInfo(p).rango, (n) => {
                                                    return (_openBlock(), _createElementBlock("label", {
                                                      key: n,
                                                      class: "fp-escala-item"
                                                    }, [
                                                      _createElementVNode("span", null, _toDisplayString(n), 1),
                                                      _cache[22] || (_cache[22] = _createElementVNode("input", {
                                                        type: "radio",
                                                        disabled: ""
                                                      }, null, -1))
                                                    ]))
                                                  }), 128)),
                                                  (escalaInfo(p).max)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(escalaInfo(p).max), 1))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : (categoriaControl(p) === 'corta')
                                                ? (_openBlock(), _createElementBlock("input", _hoisted_54))
                                                : (categoriaControl(p) === 'fecha')
                                                  ? (_openBlock(), _createElementBlock("input", _hoisted_55))
                                                  : (categoriaControl(p) === 'hora')
                                                    ? (_openBlock(), _createElementBlock("input", _hoisted_56))
                                                    : (categoriaControl(p) === 'opinion')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                          _createElementVNode("table", _hoisted_58, [
                                                            _createElementVNode("thead", null, [
                                                              _createElementVNode("tr", null, [
                                                                _cache[23] || (_cache[23] = _createElementVNode("th", null, "Variante", -1)),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.criterios, (c, i) => {
                                                                  return (_openBlock(), _createElementBlock("th", { key: i }, _toDisplayString(c), 1))
                                                                }), 128))
                                                              ])
                                                            ]),
                                                            _createElementVNode("tbody", null, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.variantes, (v, i) => {
                                                                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                                                  _createElementVNode("td", null, _toDisplayString(v), 1),
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.criterios, (_, j) => {
                                                                    return (_openBlock(), _createElementBlock("td", { key: j }, _cache[24] || (_cache[24] = [
                                                                      _createElementVNode("input", {
                                                                        type: "checkbox",
                                                                        disabled: ""
                                                                      }, null, -1)
                                                                    ])))
                                                                  }), 128))
                                                                ]))
                                                              }), 128))
                                                            ])
                                                          ])
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("textarea", _hoisted_59))
                                    ]))
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_60, "No hay preguntas asignadas a este grupo."))
                    ]))
                  }), 128))
                ]))
              : (tipoReconocido.value && !loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, _cache[25] || (_cache[25] = [
                    _createElementVNode("p", null, "Este instrumento no tiene grupos de interés ni preguntas asignadas.", -1)
                  ])))
                : _createCommentVNode("", true),
            (!instrumento.value && !loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, _cache[26] || (_cache[26] = [
                  _createElementVNode("p", null, "No se encontró información del instrumento.", -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("button", {
                class: "btn salir",
                onClick: volver
              }, "Volver"),
              (_unref(authStore).tienePermiso('instrumentos.editar') && esOpinion.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn guardar",
                    onClick: modificarInstrumento
                  }, "Modificar instrumento"))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[2] || (_cache[2] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"]),
    _createVNode(InstrumentosView, {
      visible: mostrarModalInstrumento.value,
      idTipoComponente: instrumento.value?.id_tipo_componente ?? 0,
      idIndicador: relacion.value?.id_indicador ?? 0,
      idInstrumento: instrumento.value?.id_instrumento ?? null,
      onCerrar: cerrarModalInstrumento
    }, null, 8, ["visible", "idTipoComponente", "idIndicador", "idInstrumento"]),
    _createVNode(ModificarFormularioModal, {
      visible: mostrarModificarFormulario.value,
      idInstrumento: instrumento.value?.id_instrumento ?? null,
      onCerrar: cerrarModalFormulario,
      onGuardado: onFormularioGuardado
    }, null, 8, ["visible", "idInstrumento"])
  ]))
}
}

})